import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";

import { camelToSnake } from "caseparser";

export const productsApi = api
  .enhanceEndpoints({ addTagTypes: ["paymentProcess"] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      buy: builder.mutation({
        query: ({
          branchId,
          manualType,
          data,
          client_id,
          generate_in_treasury,
          identification_type,
          number_id,
          name_client,
          email_client,
          cabys,
          method,
          direct_debit,
        }) => ({
          url: `branchs/${branchId}/store/buy`,
          method: RequestMethod.POST,
          body: camelToSnake({
            manual_type: manualType,
            data,
            client_id,
            generate_in_treasury,
            identification_type,
            number_id,
            name_client,
            email_client,
            cabys,
            method,
            direct_debit,
          }),
        }),
        invalidatesTags: ["paymentProcess"],
      }),
    }),
  });

export const {
  useBuyMutation,
} = productsApi;
